import image_logo from "../static/img/logo.png";
import dashboard_icon from "../static/img/icons/dashboard-icon.png";
import inbox_icon from "../static/img/icons/inbox-icon.png";
import task_icon from "../static/img/icons/task-icon.png";
import notepad_icon from "../static/img/icons/notepad-icon.png";
import user_image from "../static/img/user.png";
import tracks_icon from "../static/img/icons/tracks-icon.png"
import crm_icon from "../static/img/icons/crm-icon.png"
import dispatch_image from "../static/img/icons/dispatch.png"
import marketing_icon from "../static/img/icons/dispatch.png"
import analytics_icon from "../static/img/icons/analytics-icon.png"
import financial_icon from "../static/img/icons/financial.png"
import support_icon from "../static/img/icons/support-icon.png"
import location_pin from "../static/img/icons/location-pin.png"
import map_truck from "../static/img/icons/new-icon-map.png"
import server from "../static/img/icons/server.png"
import folder_icon from "../static/img/icons/folder-icon.png"
import file_icon from "../static/img/icons/file-icon.png"
import file_icon_large from "../static/img/icons/file-icon-large.png"

export let Images = {
    image_logo, dashboard_icon, inbox_icon, task_icon, notepad_icon, user_image, tracks_icon, crm_icon, dispatch_image,
    marketing_icon, analytics_icon, financial_icon, support_icon, location_pin, map_truck, server,folder_icon,
    file_icon,file_icon_large
};



// WEBPACK FOOTER //
// ./src/controller/Images.jsx